<template>
  <div>
    <div class="page-title">回報問題詳情</div>
    <div class="page-box">
      <vue-dividing-line title="基本信息"></vue-dividing-line>
      <el-row class="row-list">
        <el-col :span="12">
          題目編號 :
          <el-button
              type="text"
              size="medium" v-if="detail.question" @click="onDetailButton(detail.question.id)">{{ detail.question.questionNo }}</el-button>
        </el-col>
        <el-col :span="12"
          >語言 :
          <span v-if="detail.question">{{
            detail.question.lang | language
          }}</span>
        </el-col>
      </el-row>
      <el-row class="row-list">
        <el-col :span="12"
          >題目類型 :
          <span v-if="detail.question">{{ detail.question.type | questions }}</span>
        </el-col>
      </el-row>
      <vue-dividing-line title="問題內容"></vue-dividing-line>
      <div class="question-cte">
        <component :is="echo" v-if="form.id" :form="form"></component>
      </div>

      <vue-dividing-line title="解答思路"></vue-dividing-line>
      <div class="explanation" v-if="detail.question">
         <vue-mathjax :formula="detail.question.explanation" :safe="false"/>
      </div>
      
      <vue-dividing-line title="問題回報詳情"></vue-dividing-line>
      <el-row class="row-list">
        <el-col :span="12">
          回報人帳戶名稱 :
          <span v-if="detail.user">{{ detail.user.userNo }}</span>
        </el-col>
        <el-col :span="12">電郵地址 : {{ detail.email }} </el-col>
      </el-row>
      <el-row class="row-list">
        <el-col :span="12"> 回報類型 : <span v-if="detail.category">{{ detail.category.name }}</span> </el-col>
        <el-col :span="12"
          >回報日期和時間: {{ detail.createdAt | formatDateTime }}
        </el-col>
      </el-row>
      <el-row class="row-list">
        <el-col :span="12"> 描述問題 : {{ detail.description }}</el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import ChoiceEcho from '@/views/question/echo_components/choice/choice_echo.vue';
import DetermineEcho from '@/views/question/echo_components/determine/determine_echo.vue';
import FillingBlanksEcho from '@/views/question/echo_components/fillingBlanks/fillingBlanks_echo.vue';
import SumEcho from '@/views/question/echo_components/sum/sum_echo.vue'
import ImgDragEcho from '@/views/question/echo_components/imgDrag/imgDrag_echo.vue'
import TextDragEcho from '@/views/question/echo_components/textDrag/textDrag_echo.vue'
import TextDragEcho2 from '@/views/question/echo_components/textDrag/textDrag_echo_2.vue'
import LigatureEcho from '@/views/question/echo_components/ligature/ligature_echo.vue'
import HotspotEcho from '@/views/question/echo_components/hotspot/hotspot_echo.vue'
import { getQuestionFeedbacksDetail } from "@/api/setting";
import { toSnakeCase } from '@/utils/data-format'

export default {
  props: {
    id: {
      type: Number,
      default: 0,
    },
  },
  components: {
    ChoiceEcho,
    DetermineEcho,
    FillingBlanksEcho,
    SumEcho,
    ImgDragEcho,
    TextDragEcho,
    TextDragEcho2,
    LigatureEcho,
    HotspotEcho,
  },
  data() {
    return {
      echo: 'ChoiceEcho',
      convertType: [
        'ChoiceEcho',
        'DetermineEcho',
        'FillingBlanksEcho',
        'SumEcho',
        'HotspotEcho',
        'TextDragEcho',
        'LigatureEcho',
        'ImgDragEcho',
        'SumEcho',
        'TextDragEcho2',
      ],
      form: {},
      detail: {
        question: {},
        user: {}
      },
    };
  },
  created() {
    this.getQuestionFeedbacksDetail();
  },
  methods: {
    onDetailButton(id) {
      let path = `/question/${id}`
      this.resolveRouter(path)
    },
    getQuestionFeedbacksDetail() {
      getQuestionFeedbacksDetail(this.id).then((v) => {
        this.detail = v.data;
        this.echo = this.convertType[v.data.question.type]
        this.form = toSnakeCase(v.data.question);
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.page-box {
  margin: 20px 0;
  background-color: #fff;
  padding: 20px;
}
.row-list {
  margin-bottom: 10px;
}
.question-cte {
  width: 100%;
  min-height: 400px;
  height: fit-content;
}
</style>